import { Country, Money, ProductConditionCode, UrgencyCode } from "../../../common/models/CommonModels";
import { Page, QueryBase } from "../../../shared/models/models";


export interface CustomerRfqFeedState {
  query: RfqsQuery;
  rfqs?: Page<Rfq>;
  rfq?: Rfq;
  categories: CategoryReference[],
  loading: boolean;
  success?: string;
  error: any;
}

export interface Rfq {
  id: string;
  offerId: string;
  buyer: CustomerReference;
  country: Country;
  productNumber: string;
  productAlternativeNumber: string;
  category: CategoryReference;
  manufacturer: ManufacturerReference;
  maxUnitPrice: Money;
  quantity: number;
  urgencyCode: UrgencyCode;
  number: string;
  createdDate: Date;
  isPrivate: boolean;
  lastCall: Date;
  productConditionCodes: ProductConditionCode[];
}

export interface ChangeRfq {
  buyerId: string;
  buyer: CustomerReference;
  productNumber: string;
  productAlternativeNumber: string;
  manufacturerId: string;
  categoryId: string;
  maxUnitPrice: Money;
  quantity: number;
  description: string;
  urgencyCode: UrgencyCode;
  lastCall: Date;
  isPrivate: boolean;
  productConditionCodes: ProductConditionCode[];
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export interface CustomerReference {
  id: string;
  name: string;
  countryId: number;
  countryName: string;
}

export interface RfqsQuery extends QueryBase<RfqsQueryParameter> {
  search?: string;
  categoryId?: string;
  urgencyCode?: UrgencyCode;
  filterBy?: RfqFeedStatusCode;
  conditionCodes?: ProductConditionCode[];
}

export enum RfqFeedStatusCode {
  all = 1,
  applied = 2,
}

export enum RfqsQueryParameter {
  created = 1,
  modified = 2,
}